import { render } from "./Sliderprods.vue?vue&type=template&id=dce442e2&scoped=true"
import script from "./Sliderprods.vue?vue&type=script&lang=js"
export * from "./Sliderprods.vue?vue&type=script&lang=js"

import "./Sliderprods.vue?vue&type=style&index=0&id=dce442e2&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce442e2"]])

export default __exports__